import type { Tournament } from "@/campaigns/modules/tournament/types";

import { FinishedCampaignCard } from "./finished-campaign-card";
import { PrizeText } from "@/components/prize-text";
import { Typography } from "@/components/ui/typography";
import { campaignKey } from "@/campaigns/campaign-key";
import { formatPrizeTitle } from "@/utils/helpers";
import { useTranslation } from "react-i18next";
import { useTournamentPrize } from "@/hooks/tournaments/use-tournament-prize";

export const FinishedTournamentCard = ({
  tournament,
}: {
  tournament: Tournament;
}) => {
  const { t } = useTranslation();
  const campaign = tournament.campaign;
  const { earnedPrize } = useTournamentPrize(campaignKey(campaign));

  return (
    <FinishedCampaignCard campaign={campaign}>
      {earnedPrize ? (
        <div className="flex min-w-0 flex-1 flex-col items-start justify-center">
          <Typography tag="span" className="text-foreground">
            {t("prizes.youWon")}
          </Typography>
          {/* The prize never truncates: it shrinks, then glides over the hidden part. */}
          <PrizeText
            size="inherit"
            weight="extrabold"
            icon
            fit="marquee"
            className="w-full text-[16px] leading-6"
          >
            {formatPrizeTitle(earnedPrize.title, t)}
          </PrizeText>
        </div>
      ) : (
        <Typography tag="h5" className="min-w-0 truncate text-muted-foreground">
          {t("prizes.noWin")}
        </Typography>
      )}
    </FinishedCampaignCard>
  );
};
